import { useContext, useMemo } from 'react'

import AcademicFocusSelector from 'components/AcademicFocusSelector'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES } from '../../components/constants'

const fieldName = FIELD_NAMES.ACADEMIC_FOCUS

const AcademicFocuses = ({ focusOnly }: { focusOnly?: boolean }) => {
  const { item, onUpdateField, setSelectedAcademicFocuses } = useContext(ContentModalContext)

  const value = useMemo(() => {
    return item[fieldName] || []
  }, [item])

  return (
    <AcademicFocusSelector
      focusOnly={focusOnly}
      selectedFoci={value}
      onSelect={(value: any) => {
        onUpdateField(fieldName, value.AcademicFocus)
        setSelectedAcademicFocuses(value.AcademicFocus)
      }}
    />
  )
}

export default AcademicFocuses
